function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Text } from 'native-base';
import React, { memo, useMemo } from 'react';
import { Functions } from 'fmc-digital-common';
const TextReplacer = ({
  metadata: tempMetaData,
  content: tempContent,
  ...rest
}) => {
  const contents = useMemo(() => {
    if (!Functions.isEmpty(tempMetaData) && tempMetaData.values) {
      return Functions.textReplacer(tempContent, tempMetaData.values);
    }
    return [{
      content: tempContent,
      metadata: tempMetaData
    }];
  }, [tempMetaData, tempContent]);
  return /*#__PURE__*/React.createElement(Text, null, contents.map(({
    content,
    metadata
  }) => {
    return /*#__PURE__*/React.createElement(Text, _extends({}, metadata, rest, {
      testID: content,
      accessibilityLabel: content,
      accessibilityRole: "text"
    }), content);
  }));
};
export default /*#__PURE__*/memo(TextReplacer);
//# sourceMappingURL=index.js.map